$(document).ready(function () {
  $(document).on(
    "click",
    ".collection_new_title ul li a,.scroll_to_hash  .explore_apparel_col",
    function (event) {
      event.preventDefault();

      $("html, body").animate(
        {
          scrollTop: $($.attr(this, "href")).offset().top,
        },
        1500,
      );
    },
  );
  var text = $(".rc_label__discount").text();
  var text2 = text.replace("%", "% Off");
  $(".rc_label__discount").text(text2);

  var url = window.location.href;

  if (url.indexOf("type=article") > -1) {
    $(".search_blog").addClass("active");
  } else {
    $(".search_products").addClass("active");
  }

  if(document.body.classList.contains('template-search') || document.body.classList.contains('template-collection')) {
    const sortBy = document.querySelector('#SortBy');
    sortBy?.addEventListener('keydown', (event) => {      
      if (["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(event.key)) {
        event.preventDefault();
      }
    });
  }

  const returnTo = new URLSearchParams(window.location.search).get('return_to');

  if(returnTo && returnTo.startsWith('/') && !returnTo.startsWith('//')) {
    const signInUrl = '/customer_authentication/login?return_to=' + encodeURIComponent(returnTo);
    const signInPaths = ['/account', '/account/login', '/customer_authentication/login', '/customer_authentication/redirect'];

    document.querySelectorAll('a[href]').forEach((link) => {
      if(link.origin === window.location.origin && signInPaths.includes(link.pathname)) {
        link.href = signInUrl;
      }
    });
  }
});

// Filter Products Start
setTimeout(function () {
  if ($(".filter-more-filters").length) {
    var filters = $(".filter-more-filters .collapsible-content__inner ul")
      .html()
      .trim();
    if (filters == "") {
      $(".filter-more-filters").hide();
    }
  }
}, 300);
// Filter Products End

// Search Products Start
$(document).on("click", ".search_products", function () {
  var url = window.location.href;
  var updated_url1 = url.replace("%2Carticle%2Cpage%2Ccollection", "");
  var updated_url = updated_url1.replace("type=article", "type=product");

  if (url.indexOf("&page") > -1) {
    updated_url = updated_url.replace("page=", "");
  }
  window.location.href = updated_url;
});

$(document).on("click", ".search_blog", function () {
  var url = window.location.href;
  var updated_url1 = url.replace("%2Carticle%2Cpage%2Ccollection", "");
  var updated_url = updated_url1.replace("type=product", "type=article");

  if (url.indexOf("&page") > -1) {
    updated_url = updated_url.replace("page=", "");
  }
  window.location.href = updated_url;
});
// Search Products Start End

// Product Lightbox
$(document).on("mouseenter", ".product-main-slide", function () {
  $(".product-main-slide").removeClass("is-selected");
  $(this).addClass("is-selected");
});
// Product Lightbox End


document.addEventListener('DOMContentLoaded', () => {
  const upsellProductsWrapper = document.querySelectorAll('[data-upsell-product]');
  const pdpBundleProductsWrapper = document.querySelectorAll('[data-pdp-bundle-product]');

  class UpsellProduct {
    constructor(container) {
      this.container = container;
      this.form = this.container.querySelector('form');
      this.singleOptionSelectors = this.container.querySelectorAll('[data-upsell-variant-input]');
      this.sizeSelect = this.container.querySelector('select[data-upsell-select-variant-input]');
      this.upsellFormSelect = this.form.querySelector('[data-upsell-product-select]');
      this.upsellFormAtc = this.form.querySelector('[data-upsell-add-to-cart]');
      this.upsellFormAtcTexts = this.upsellFormAtc.querySelectorAll('span');
      this.optionName = this.container.querySelector('[data-upsell-option-name]');
      this.image = this.container.querySelector('[data-upsell-featured-image]')
    }

    async init() {
      if (!this.container) return;

      this.listenChanges();
      this.listenFormSubmit();
    }

    listenChanges() {
      const updateConcatValue = () => {
        const sizeValue = this.sizeSelect?.value || "";
        const selectedSwatch = Array.from(this.singleOptionSelectors)?.find(el => el.checked)?.value || "";
        const concatValue = selectedSwatch && sizeValue
          ? `${selectedSwatch} / ${sizeValue}`
          : (selectedSwatch || sizeValue);        
        const match = Array.from(this.upsellFormSelect.options)?.find(option => option.label === concatValue);

        this.optionName.innerHTML = selectedSwatch;

        if (match) {
          const variantImage = match.dataset.variantFeaturedImage;
          if (variantImage) {
            const cleanImageUrl = variantImage.split('?')[0];

            this.image.src = cleanImageUrl;
            this.image.srcset = cleanImageUrl;
          }

          if (!match.disabled) {
            this.upsellFormAtc.disabled = false;
            this.upsellFormAtcTexts.forEach((el, index) => {
              el.innerText = index === 0 ? 'Add to cart' : 'Add';
            });
            this.upsellFormSelect.value = match.value;
            this.upsellFormSelect.dispatchEvent(new Event("change", { bubbles: true }));
            return;
          }
        }

        // If no match or match is disabled
        this.upsellFormAtc.disabled = true;
        this.upsellFormAtcTexts.forEach((el) => {
          el.innerText = 'Sold out';
        });
      };

      this.singleOptionSelectors?.forEach(selector => {
        selector.addEventListener("change", updateConcatValue);
      });

      this.sizeSelect?.addEventListener("change", updateConcatValue);

      updateConcatValue();
    }

    listenFormSubmit() {
      const cartIcon = document.querySelector('.js-drawer-open-cart');
      this.form.addEventListener("submit", function (event) {
        event.preventDefault();
        const addToCart = event.target.querySelector('[data-upsell-add-to-cart]');
        var itemData = theme.utils.serialize(event.target);
        addToCart.classList.add('btn--loading');

        fetch("/cart/add.js", {
          method: "POST",
          body: itemData,
        })
        .then(() => {
          document.dispatchEvent(new CustomEvent("cart:build"));
          cartIcon.click();
        })
        .catch((error) => {
          console.error("Error:", error);
          alert("Failed to add product. Please try again.");
        }).finally(() => {
          addToCart.classList.remove('btn--loading');
        });
      });
    }
  }

  upsellProductsWrapper?.forEach(container => {
    const upsellInstance = new UpsellProduct(container);
    upsellInstance.init();
  });

  class PdpBundleProduct {
    constructor(container) {
      this.container = container;
      this.form = this.container.querySelector('form');
      this.pdpBundleFormAtc = this.form?.querySelector('[data-pdp-bundle-add-to-cart]');
      this.pdpBundleFormAtcTexts = this.pdpBundleFormAtc?.querySelectorAll('span');
    }

    async init() {
      if (!this.container || !this.form) return;
      this.listenFormSubmit();
    }

    listenFormSubmit() {
      const cartIcon = document.querySelector('.js-drawer-open-cart');
      this.form.addEventListener("submit", (event) => {
        event.preventDefault();
        const addToCart = event.target.querySelector('[data-pdp-bundle-add-to-cart]');
        if (!addToCart) {
          return;
        }
        var itemData = theme.utils.serialize(event.target);
        addToCart.classList.add('btn--loading');

        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          },
          body: itemData,
        })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          document.dispatchEvent(new CustomEvent("cart:build"));
          if (cartIcon) cartIcon.click();
        })
        .catch((error) => {
          console.error("Error:", error);
          alert("Failed to add product. Please try again.");
        }).finally(() => {
          addToCart.classList.remove('btn--loading');
        });
      });
    }
  }

  pdpBundleProductsWrapper?.forEach(container => {
    const pdpBundleInstance = new PdpBundleProduct(container);
    pdpBundleInstance.init();
  });
});

document.addEventListener("click", function (event) {
  if (event.target.closest("[data-add-to-cart]")) {
    let rebuyWidgetContainer = document.querySelector('.rebuy-widget.widget-type-switch-to_subscription .rebuy-widget-content');

    if(!rebuyWidgetContainer) return;

    let rebuyModalClose = rebuyWidgetContainer.querySelector('.rebuy-modal-close');
    if (rebuyModalClose) {
      rebuyModalClose.setAttribute('tabindex', '0');
    }

    if (rebuyWidgetContainer) {
      // tabindex="-1", not "0": .focus() below still works, but the container does not
      // linger as a tab stop afterwards. Matches theme.js trapFocus, which sets -1 on
      // its container for the same reason.
      rebuyWidgetContainer.setAttribute('tabindex', '-1');
      setTimeout(() => {
        rebuyWidgetContainer.focus();
      }, 1000);
    }
  }
});

document.addEventListener("click", function (event) {
  const label = event.target.closest(".accordion__label");

  if (label) {
    const content = label.nextElementSibling; // Assuming content is the next sibling
    if (content && content.classList.contains("accordion__content")) {
      content.style.display = content.style.display === "block" ? "none" : "block";
    }
  }
});

// Flavor Swatch Sliding Animation
document.addEventListener('DOMContentLoaded', function() {
  const flavorWrappers = document.querySelectorAll('.variant-wrapper--flavor .variant-input-wrap');

  if (!flavorWrappers) return;

  flavorWrappers.forEach(wrapper => {
    const radioInputs = wrapper.querySelectorAll('input[type="radio"]');
    const animatedElement = wrapper;

    function updateSliderPosition() {
      const checkedInput = wrapper.querySelector('input[type="radio"]:checked');

      if (checkedInput) {
        const checkedLabel = checkedInput.parentElement;
        const labelRect = checkedLabel.getBoundingClientRect();
        const wrapperRect = wrapper.getBoundingClientRect();

        // Calculate horizontal position (center of swatch)
        const leftPosition = labelRect.left - wrapperRect.left + (labelRect.width / 2);

        // Calculate vertical position (bottom of swatch + small offset)
        const topPosition = labelRect.top - wrapperRect.top + labelRect.height + 10;

        // Update the CSS variables directly 
        animatedElement.style.setProperty('--slider-left', `${leftPosition}px`);
        animatedElement.style.setProperty('--slider-top', `${topPosition}px`);
        animatedElement.style.setProperty('--slider-opacity', '1');
      } else {
        animatedElement.style.setProperty('--slider-opacity', '0');
      }
    }

    // Listen for changes on all radio inputs in this wrapper
    radioInputs.forEach(input => {
      input.addEventListener('change', updateSliderPosition);
    });

    // Recalculate on resize (important if layout changes between mobile/desktop)
    window.addEventListener('resize', updateSliderPosition);

    // Initialize position if there's a checked input on page load
    updateSliderPosition();
  });
});
function updateRebuyShortDescriptions(widget) {
  if (widget.id == "223025") {
    const products = widget.data.products;

    products.forEach(product => {
      const productIdClass = `product-id-${product.id}`;
      const productElement = widget.template.querySelector(`.${productIdClass}`);

      if (productElement) {
        const productShortDescription = product?.metafields?.my_fields?.short_description;
        const productReview = productElement.querySelector('.rebuy-product-info .rebuy-product-review');
        const existingShortDesc = productElement.querySelector('.rebuy-product-short-description');
        if (existingShortDesc) {
          existingShortDesc.remove();
        }

        if (productReview && productShortDescription) {
          const shortDescriptionEl = document.createElement('span');
          shortDescriptionEl.classList.add('rebuy-product-short-description');
          shortDescriptionEl.innerHTML = productShortDescription;

          productReview.insertAdjacentElement('beforebegin', shortDescriptionEl);
        }
      }
    });
  }
}

document.addEventListener('rebuy.ready', function(event) {
  updateRebuyShortDescriptions(event.detail.widget);
});

document.addEventListener('rebuy.productsChange', function(event) {
  setTimeout(() => {
    updateRebuyShortDescriptions(event.detail.widget);
  }, 500);
});

document.addEventListener('variant:change', function(event) {
  const { variant } = event.detail;

  if (!variant) return;

  const finalPriceLabel = document.querySelector('[data-final-price-label]');
  if (!finalPriceLabel) return;

  const hasFinalPrice = variant.metafields?.custom?.final_price === true;

  if (hasFinalPrice) {
    if (!finalPriceLabel.querySelector('.final-price-text')) {
      const span = document.createElement('span');
      span.className = 'final-price-text';
      span.textContent = '- FINAL SALE';
      finalPriceLabel.innerHTML = '';
      finalPriceLabel.appendChild(span);
    }
  } else {
    finalPriceLabel.innerHTML = '';
  }
});
